import { useParams } from "react-router-dom";

export default function useFacilityId() {
  const facilityId = Number(useParams().facilityId);

  return facilityId;
}
